export default "__VITE_ASSET__Cq27zlBb__"